// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-criminal-grid-index .decisionGridContainer {
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  padding: 10px;
  background: #fff;
}
app-criminal-grid-index .mdc-tab--active {
  background-color: white !important;
}
app-criminal-grid-index .mdc-tab {
  background-color: #e6e4e6;
}
app-criminal-grid-index .mdc-button {
  box-shadow: none;
}
app-criminal-grid-index .mat-form-field {
  background-color: white !important;
}
app-criminal-grid-index .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: white;
  height: 40px;
}
app-criminal-grid-index .button-row {
  position: absolute;
  align-items: flex-end;
  width: 99%;
  max-width: 99%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/app/decision-grid/criminal-grid-index.component.less"],"names":[],"mappings":"AAAA;EAGI,WAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AADJ;AANA;EAWI,kCAAA;AAFJ;AATA;EAeI,yBAAA;AAHJ;AAZA;EAqBI,gBAAA;AANJ;AAfA;EAyBI,kCAAA;AAPJ;AAlBA;EA6BI,uBAAA;EACA,YAAA;AARJ;AAtBA;EAkCI,kBAAA;EAEA,qBAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EAEA,aAAA;EACA,mBAAA;EACA,yBAAA;AAXJ","sourcesContent":["app-criminal-grid-index {\n\n  .decisionGridContainer {\n    width: 100%;\n    max-width: 100%;\n    min-width: 100%;\n    padding: 10px;\n    background: #fff;\n  }\n\n  .mdc-tab--active {\n    background-color: white !important;\n  }\n\n  .mdc-tab {\n    background-color: #e6e4e6;\n    // width: 300px;\n    // height: 70px;\n  }\n\n  .mdc-button {\n    box-shadow: none;\n  }\n\n  .mat-form-field {\n    background-color: white !important;\n  }\n\n  .mdc-text-field--filled:not(.mdc-text-field--disabled) {\n    background-color: white;\n    height: 40px;\n  }\n\n  .button-row {\n    position: absolute;\n    display: flex;\n    align-items: flex-end;\n    width: 99%;\n    max-width: 99%;\n    background: white;\n\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
